import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import $ from 'jquery';

import * as offerActions from '../../../redux/newOffer';
import ModalQuestion from '../../ModalQuestion';
import { AnalyticsService } from '../../../services/AnalyticsService';

const Button = styled.div`
  width: 80px;
  height: 25px;
  font-family: BrandonGrotesque-Regular;
  background-color: var(--color-gunmetal);
  font-size: 15px;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  letter-spacing: 1px;
  color: #ffffff;
  margin-right: 29px;
`;

function CancelCreateOffer(props) {
  return (
    <>
      <Button onClick={() => $('#cancelCreateOffer').modal('show')}>CANCEL</Button>
      <ModalQuestion
        title="Change offer type?"
        leftName="Cancel"
        rightName="OK"
        id="cancelCreateOffer"
        function={() => {
          AnalyticsService.track('Cancel create offer', {});
          props.offerActions.cancelCreate();
        }}
      >
        Are you sure you want to cancel? <br />
        All data you entered will be deleted.
        <br />
      </ModalQuestion>
    </>
  );
}

const mapStateToProps = (state) => ({});
function mapDispatchToProps(dispatch) {
  return {
    offerActions: bindActionCreators(offerActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CancelCreateOffer);
